"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABUSE_WORDS = void 0;
exports.containsAbuseWord = containsAbuseWord;
function containsAbuseWord(message) {
    const lowercasedMessage = message.toLowerCase();
    for (const word of exports.ABUSE_WORDS) {
        const regex = new RegExp(`\\b${word.toLowerCase()}\\b`);
        if (lowercasedMessage.match(regex)) {
            return true;
        }
    }
    return false;
}
// Could have more complete list
// List is google bad words list. Taken from: https://www.freewebheaders.com/full-list-of-bad-words-banned-by-google/
// Facebook have more extensive lists. Can be found at same link as above
// Cannot find direct links on google, facebook, twitter etc
// Commented out phrases not explicitly removed as make sense to include from a medical perspective
exports.ABUSE_WORDS = [
    //            "anal", //allow
    //            "anus", //allow
    "arse",
    //            "ass", //allow - often typo of as or shorthand for assessment
    //            "ass fuck", //duplicate with "fuck" below
    "ass hole", //no longer duplicate with "ass" above
    "assfucker",
    "asshole",
    "assshole",
    "bastard",
    "bitch",
    //            "black cock", //duplicate with "cock" below
    "bloody hell",
    "boong",
    //            "cock", //allow
    "cockfucker",
    "cocksuck",
    "cocksucker",
    //            "coon",    // often a name
    "coonnass",
    //            "crap",    // often used as colloquial term of stool samples
    "cunt",
    "cyberfuck",
    //            "damn", //allow
    //            "darn", //allow
    //            "dick", //allow
    //            "dirty", //allow
    //            "douche", //allow
    //            "dummy", //allow
    //            "erect", //allow
    //            "erection", //allow
    //            "erotic", //allow
    //            "escort", //allow
    //            "fag", //allow - used as slang for cigarette
    "faggot",
    "fuck",
    "fucker",
    //            "fuck off", //duplicate with "fuck" above
    //            "fuck you", //duplicate with "fuck" above
    "fuckass",
    "fuckhole",
    "god damn",
    //            "gook", //allow
    "hard core",
    "hardcore",
    "homoerotic",
    //            "hore", //allow
    //            "lesbian", //allow
    //            "lesbians", //allow
    //            "mother fucker", //duplicate with "fucker" above
    "motherfuck",
    "motherfucker",
    //            "negro",    // often a name
    "nigger",
    //            "orgasim", //allow
    //            "orgasm", //allow
    //            "penis", //allow
    "penisfucker",
    "piss",
    //            "piss off", //duplicate with "piss" above
    //            "porn",    // porn addiction is a legit use case
    //            "porno",    // porn addiction is a legit use case
    //            "pornography",    // porn addiction is a legit use case
    //            "pussy", //allow - used in context of pus filled spot
    //            "retard", //allow - used in medication names to signify modified release version of medication
    "sadist",
    //            "sex", //allow
    "sexy",
    //            "shit",    // allow
    "slut",
    //            "son of a bitch", //duplicate with "bitch" above
    //            "suck", //allow
    "tits",
    //            "viagra", //allow
    "wank",
    "wanker",
    "whore",
    //            "xxx" //allow - common placeholder for date/name
];
//# sourceMappingURL=AbuseWordsHelper.js.map